module.exports = __webpack_public_path__ + "static/media/caret-down.cd2f024c.svg";